import type { ConversationStatus } from "@/types/api";

export interface StatusMeta {
  label: string;
  /** Shorter label used in the conversation-list group header. */
  groupLabel: string;
  dot: string;
  bg: string;
  fg: string;
}

export const STATUS_META: Record<ConversationStatus, StatusMeta> = {
  discussing: { label: "Discussing", groupLabel: "Discussing", dot: "#7B8794", bg: "#EEF0F2", fg: "#3D4651" },
  needs_it_review: { label: "Needs IT review", groupLabel: "Needs IT review", dot: "#5B5BD6", bg: "#ECEBFA", fg: "#3F3EAF" },
  prd_pending_confirm: { label: "PRD pending confirm", groupLabel: "Pending confirm", dot: "#C58E1B", bg: "#FAF1DC", fg: "#7A5A12" },
  prd_confirmed: { label: "PRD confirmed", groupLabel: "Confirmed", dot: "#2C7A4F", bg: "#E4F1E8", fg: "#1E5536" },
  rejected: { label: "Rejected", groupLabel: "Rejected", dot: "#B33B3B", bg: "#F8E3E3", fg: "#7E2828" },
  closed: { label: "Closed", groupLabel: "Closed", dot: "#9CA3AF", bg: "#EDEDED", fg: "#555555" },
};

/** Visual ordering of status groups in the conversation list. */
export const STATUS_ORDER: readonly ConversationStatus[] = [
  "discussing",
  "needs_it_review",
  "prd_pending_confirm",
  "prd_confirmed",
  "rejected",
  "closed",
];

export function statusMetaFor(status: string): StatusMeta {
  return STATUS_META[status as ConversationStatus] ?? STATUS_META.closed;
}
